import React from "react";

const FormValueFieldPreview = props => {
  const {value, className} = props;

  const classes = `fs-6 fw-bolder text-primary-cermaq ${className}`;

  return <div className={classes}>{value}</div>;
};

export default FormValueFieldPreview;
